import { PHOTO_URL } from './apiutils'
import { resolvePlatformUser } from './customerDisplay'

// 沒有頭像時回傳 null，由 components/common/CustomerAvatar 顯示預設樣式（姓名首字）。
// 以前這裡放的是 randomuser.me 的陌生人照片，看起來像客人本人，容易誤會。
const DEFAULT_AVATAR = null

function toFullUrl(avatar) {
  if (!avatar) return null
  if (avatar.startsWith('http://') || avatar.startsWith('https://')) {
    return avatar
  }
  return `${PHOTO_URL}${avatar}`
}

/**
 * 顧客頭像 URL。
 * LINE 用戶優先使用 userInfo.avatar：多與 LINE 同步、較新；Customer.avatar 常為舊的
 * profile.line-scdn.net 簽章連結，過期後列表若改讀 userInfo 仍正常、詳情頁卻會空白。
 * 非 LINE 用戶仍優先 customer.avatar（店家上傳多在此）。
 */
export function getCustomerAvatarSrc(customer) {
  if (!customer) return DEFAULT_AVATAR

  const udoc = resolvePlatformUser(customer)
  const isLine =
    customer.isLineUser === true ||
    customer.platformData?.isLineUser === true ||
    udoc?.isLineUser === true ||
    !!(udoc?.lineId || udoc?.isLineConnected)

  if (isLine) {
    const u = toFullUrl(udoc?.avatar)
    if (u) return u
    const c = toFullUrl(customer.avatar)
    if (c) return c
    return DEFAULT_AVATAR
  }

  const c = toFullUrl(customer.avatar)
  if (c) return c
  const u = toFullUrl(udoc?.avatar)
  if (u) return u
  return DEFAULT_AVATAR
}

/** 列表卡片：無頭像時回傳 null，改顯示首字占位 */
export function getCustomerAvatarSrcForListCard(customer) {
  if (!customer) return null

  const udoc = resolvePlatformUser(customer)
  const isLine =
    customer.isLineUser === true ||
    customer.platformData?.isLineUser === true ||
    udoc?.isLineUser === true ||
    !!(udoc?.lineId || udoc?.isLineConnected)

  if (isLine) {
    const u = toFullUrl(udoc?.avatar)
    if (u) return u
    const c = toFullUrl(customer.avatar)
    return c || null
  }

  const c = toFullUrl(customer.avatar)
  if (c) return c
  const u = toFullUrl(udoc?.avatar)
  return u || null
}
